import { Link } from "react-router-dom";
import { Instagram, ArrowUpRight } from "lucide-react";
import { INFO } from "../data/site";

export const Footer = () => (
  <footer className="border-t border-line bg-base" data-testid="footer">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <h2 className="font-display text-6xl sm:text-8xl uppercase leading-[0.85]">
            Banga<br />Bowls<span className="text-harissa">.</span>
          </h2>
          <p className="font-sans text-muted mt-6 max-w-md">{INFO.tagline}</p>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.15em] text-muted mb-4">Navigieren</p>
          <ul className="space-y-2 font-head text-xl">
            <li><Link to="/menu" className="hover:text-harissa transition-colors">Karte</Link></li>
            <li><Link to="/story" className="hover:text-harissa transition-colors">Story</Link></li>
            <li><Link to="/events" className="hover:text-harissa transition-colors">Events</Link></li>
            <li><Link to="/reservierung" className="hover:text-harissa transition-colors">Reservieren</Link></li>
            <li><Link to="/kontakt" className="hover:text-harissa transition-colors">Kontakt</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.15em] text-muted mb-4">Finden</p>
          <ul className="space-y-2 font-mono text-sm text-ink">
            <li>{INFO.city}</li>
            <li>{INFO.hours}</li>
            <li>{INFO.email}</li>
            <li>
              <a href={INFO.instagramUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-mango transition-colors" data-testid="footer-instagram">
                <Instagram size={14} /> {INFO.instagram} <ArrowUpRight size={12} />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t border-line flex flex-col sm:flex-row justify-between gap-3 font-mono text-xs text-muted uppercase tracking-wider">
        <span>© {new Date().getFullYear()} Banga Bowls · Pop-Up</span>
        <span>Maghreb meets West Africa</span>
      </div>
    </div>
  </footer>
);
